import { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Home from "./Components/main/pages/Homepage";

// Android:
import SendInapp from "./Components/inapp/Sendinapp";
import TestSDKIntegration from "./Components/startsdk/TestSDKIntegration";

// Ios:
//page8
import InApp_TestSDKIntegration from "./Components/inapp/TestInappIntegration";
//page9

import { Route, Routes, BrowserRouter } from "react-router-dom";

import DL_prepareURI from "./Components/deeplinking/ios/DL_prepareURI";
import DL_prepareUniversalLinks from "./Components/deeplinking/ios/DL_prepareUniversalLinks";
import DL_implementCodeIOS from "./Components/deeplinking/ios/DL_implementCodeIOS";
import DL_testDeferredIOS from "./Components/deeplinking/ios/DL_testDeferredIOS";
import TestDeferredDL from "./Components/deeplinking/TestDeferredDL";
import DL_testDirectManual from "./Components/deeplinking/DL_testDirectManual";

import DL_prepareAndroid from "./Components/deeplinking/android/DL_prepare1Android";
import DL_prepare2Android from "./Components/deeplinking/android/DL_prepare2Android";
import DL_implementAndroid from "./Components/deeplinking/android/DL_implementAndroid";
import TestDeferredAndroid from "./Components/deeplinking/android/DL_TestDeferredAndroid";

import AppParameter from "./Components/main/pages/AppParameters";
import InstallSDK from "./Components/startsdk/ios/installSDK";
import InstallSDKandroid from "./Components/startsdk/android/InstallSDK";
import StartSDKiOS from "./Components/startsdk/ios/StartSDKiOS";
import StartSDKAndroid from "./Components/startsdk/android/StartSDKAndroid";
import ReferrerPage from "./Components/startsdk/android/ReferrerPage";
import InstallSDKPermissions from "./Components/startsdk/android/InstallSDKPermissions";
import TestSDKUID from "./Components/startsdk/TestSDKUID";
import TestResultManual from "./Components/startsdk/TestResultManual";
import Layout from "./Components/main/components/Layout";

import IntegrationPath from "./Components/main/pages/integrationPath";
import ChooseOsPath from "./Components/main/pages/ChooseOsPath";
import DeferredOrDirectAndroid from "./Components/deeplinking/DeferredOrDirect";

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@appsflyer/fe-ui-theme";
import theme from "./theme";
import "./App.css";
import Finish from "./Components/main/pages/Finish";
import TestingTypePath from "./Components/main/pages/TestingTypePath";
import TestConsole_Register from "./Components/main/pages/TestConsole_Register";
import TestConsole_Results from "./Components/main/pages/TestConsole_Results";
import DL_prepareUniversalLinks2 from "./Components/deeplinking/ios/DL_prepareUniversalLinks2";
import DL_prepare3Android from "./Components/deeplinking/android/DL_prepare3Android";
import StartSDKAndroidGCD from "./Components/startsdk/android/StartSDKAndroidGCD";
import StartSDKiOSGCD from "./Components/startsdk/ios/StartSDKiOSGCD";
import { useIdleTimer } from "react-idle-timer";
import NotFound from "./Components/main/pages/NotFound";

import * as amplitude from "@amplitude/analytics-browser";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";
import EvgenWrapper from "./Components/inapp/EvgenWrapper";
import ProGuardPage from "./Components/startsdk/android/ProGuardPage";
import AdRevenueSDK from "./Components/adRevenue/AdRevenueSDK";
import AdRevenue_TestManual from "./Components/adRevenue/AdRevenue_TestManual";
import AdRevenue_TestAutomated from "./Components/adRevenue/AdRevenue_TestAutomated";
import ChoosePathMigration from "./Components/main/pages/ChoosePathMigration";
import SdkMigration from "./Components/main/pages/SdkMigration";

export default function App() {
  const [isPaused, setIsPaused] = useState(false);
  const [timeCounter, setTimeCounter] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPaused) {
        setTimeCounter(timeCounter + 1);
        // console.log("timeCounter", timeCounter);
      }
    }, 1000);
    return () => clearInterval(interval);
  });

  useEffect(() => {
    // amplitude.setUserId('dj@appsflyer.com');

    // Create and Install Session Replay Plugin
    const sessionReplayTracking = sessionReplayPlugin();
    amplitude.add(sessionReplayTracking);

    // Your existing initialization logic with Browser SDK
    amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY, {
      defaultTracking: {
        sessions: true,
        formInteractions: true,
        attribution: {
          excludeReferrers: [],
        },
      },
    });
  }, []);

  const onIdle = () => {
    // console.log("User is idle", event);
    setIsPaused(true);
  };

  const onActive = () => {
    // console.log("User is active", event);
    setIsPaused(false);
  };

  useIdleTimer({
    onIdle,
    onActive,
    timeout: 60_000,
    throttle: 500,
  });

  // const theme = useTheme();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg">
        <Box sx={{ my: 4 }}>
          <BrowserRouter>
            <div>
              <Routes>
                <Route element={<Layout sessionTime={timeCounter} />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/home" element={<Home />} />
                  <Route path="/finish" element={<Finish />} />
                  <Route path="/chooseospath" element={<ChooseOsPath />} />
                  <Route path="/appparams" element={<AppParameter />} />
                  <Route
                    path="/integrationpath"
                    element={<IntegrationPath />}
                  />
                  {/* <Route path="/test" element={<Test />} /> */}
                  {/* migration */}
                  <Route
                    path="/choosePathMigration"
                    element={<ChoosePathMigration />}
                  />
                  {/* migration startsdk */}
                  <Route
                    path="/migration/startsdk/android/sdkMigration"
                    element={<SdkMigration />}
                  />
                  <Route
                    path="/migration/startsdk/android/testsdkintegration"
                    element={<TestSDKIntegration />}
                  />
                  <Route
                    path="/migration/startsdk/android/testtype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/migration/startsdk/android/testconsole"
                    element={<TestConsole_Register />}
                  />
                  {/* migration in-app */}
                  <Route
                    path="/migration/inapp/android/sdkMigration"
                    element={<SdkMigration />}
                  />
                  <Route
                    path="/migration/inapp/android/testinappintegration"
                    element={<InApp_TestSDKIntegration />}
                  />
                  <Route
                    path="/migration/inapp/android/testtype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/migration/inapp/android/sendinapp"
                    element={<SendInapp />}
                  />
                  <Route
                    path="/migration/inapp/android/testtype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/migration/inapp/android/testconsole"
                    element={<TestConsole_Register />}
                  />
                  <Route element={<EvgenWrapper />}>
                    <Route
                      path="/migration/inapp/android/evgenevents"
                      element={<TestConsole_Results />}
                    />
                    <Route
                      path="/migration/inapp/android/evgeneventsmanual"
                      element={<InApp_TestSDKIntegration />}
                    />
                  </Route>
                  {/* migration deeplink */}
                  <Route
                    path="/migration/deeplink/android/sdkMigration"
                    element={<SdkMigration />}
                  />
                  <Route
                    path="/migration/deeplink/android/testconsole"
                    element={<TestConsole_Register />}
                  />
                  <Route
                    path="/migration/deeplink/android/testdeferred"
                    element={<TestDeferredAndroid />}
                  />
                  <Route
                    path="/migration/deeplink/android/testdeferreddl"
                    element={<TestDeferredDL />}
                  />
                  <Route
                    path="/migration/deeplink/android/deeplinktype"
                    element={<DeferredOrDirectAndroid />}
                  />
                  <Route
                    path="/migration/deeplink/android/testtype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/migration/deeplink/android/testDirect"
                    element={<DL_testDirectManual />}
                  />
                  <Route
                    path="/migration/deeplink/android/testtype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/migration/deeplink/android/testconsole"
                    element={<TestConsole_Register />}
                  />
                  <Route
                    path="/migration/deeplink/android/eventstestconsole"
                    element={<TestConsole_Results />}
                  />
                  {/* startSDK */}
                  <Route
                    path="/startsdk/android/testresults"
                    element={<TestResultManual />}
                  />
                  <Route
                    path="/startsdk/ios/testresults"
                    element={<TestResultManual />}
                  />
                  {/* ios path */}
                  <Route
                    path="/startsdk/ios/installsdk"
                    element={<InstallSDK />}
                  />
                  <Route
                    path="/startsdk/ios/setGCD"
                    element={<StartSDKiOSGCD />}
                  />
                  <Route
                    path="/startsdk/ios/startsdk"
                    element={<StartSDKiOS />}
                  />
                  <Route
                    path="/startsdk/ios/testsdkintegration"
                    element={<TestSDKIntegration />}
                  />
                  <Route
                    path="/startsdk/ios/testsdktype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/startsdk/ios/testconsole"
                    element={<TestConsole_Register />}
                  />
                  <Route
                    path="/startsdk/ios/eventstestconsole"
                    element={<TestConsole_Results />}
                  />
                  <Route
                    path="/startsdk/ios/testsdkuid"
                    element={<TestSDKUID />}
                  />
                  {/* android path */}
                  <Route
                    path="/startsdk/android/installsdk"
                    element={<InstallSDKandroid />}
                  />
                  <Route
                    path="/startsdk/android/setpermissions"
                    element={<InstallSDKPermissions />}
                  />
                  <Route
                    path="/startsdk/android/startsdk"
                    element={<StartSDKAndroid />}
                  />
                  <Route
                    path="/startsdk/android/setGCD"
                    element={<StartSDKAndroidGCD />}
                  />
                  <Route
                    path="/startsdk/android/referrer"
                    element={<ReferrerPage />}
                  />
                  <Route
                    path="/startsdk/android/proguard"
                    element={<ProGuardPage />}
                  />
                  <Route
                    path="/startsdk/android/testsdkintegration"
                    element={<TestSDKIntegration />}
                  />
                  <Route
                    path="/startsdk/android/testsdktype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/startsdk/android/testconsole"
                    element={<TestConsole_Register />}
                  />
                  <Route
                    path="/startsdk/android/eventstestconsole"
                    element={<TestConsole_Results />}
                  />
                  <Route
                    path="/startsdk/android/testsdkuid"
                    element={<TestSDKUID />}
                  />
                  <Route
                    path="/deeplink/android/prepare"
                    element={<DL_prepareAndroid />}
                  />
                  <Route
                    path="/deeplink/android/prepare2"
                    element={<DL_prepare2Android />}
                  />
                  <Route
                    path="/deeplink/android/prepare3"
                    element={<DL_prepare3Android />}
                  />
                  <Route
                    path="/deeplink/android/implement"
                    element={<DL_implementAndroid />}
                  />
                  <Route
                    path="/deeplink/android/testdeferred"
                    element={<TestDeferredAndroid />}
                  />
                  <Route
                    path="/deeplink/android/testdeferreddl"
                    element={<TestDeferredDL />}
                  />
                  <Route
                    path="/deeplink/android/deeplinktype"
                    element={<DeferredOrDirectAndroid />}
                  />
                  <Route
                    path="/deeplink/android/testDirect"
                    element={<DL_testDirectManual />}
                  />
                  <Route
                    path="/deeplink/android/testtype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/deeplink/android/testconsole"
                    element={<TestConsole_Register />}
                  />
                  <Route
                    path="/deeplink/android/eventstestconsole"
                    element={<TestConsole_Results />}
                  />
                  <Route
                    path="/deeplink/ios/prepare"
                    element={<DL_prepareUniversalLinks />}
                  />
                  <Route
                    path="/deeplink/ios/prepare2"
                    element={<DL_prepareUniversalLinks2 />}
                  />
                  <Route
                    path="/deeplink/ios/prepareURI"
                    element={<DL_prepareURI />}
                  />
                  <Route
                    path="/deeplink/ios/implement"
                    element={<DL_implementCodeIOS />}
                  />
                  <Route
                    path="/deeplink/ios/testdeferred"
                    element={<DL_testDeferredIOS />}
                  />
                  <Route
                    path="/deeplink/ios/testdeferreddl"
                    element={<TestDeferredDL />}
                  />
                  <Route
                    path="/deeplink/ios/testDirect"
                    element={<DL_testDirectManual />}
                  />
                  <Route
                    path="/deeplink/ios/deeplinktype"
                    element={<DeferredOrDirectAndroid />}
                  />
                  <Route
                    path="/deeplink/ios/testtype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/deeplink/ios/testconsole"
                    element={<TestConsole_Register />}
                  />
                  <Route
                    path="/deeplink/ios/eventstestconsole"
                    element={<TestConsole_Results />}
                  />
                  <Route path="/home" element={<Home />} />
                  {/* <Route path="/test" element={<TestComponent />} /> */}
                  {/* Apple */}
                  <Route path="/inapp/ios/sendinapp" element={<SendInapp />} />
                  <Route
                    path="/inapp/ios/testinappintegration"
                    element={<InApp_TestSDKIntegration />}
                  />
                  <Route
                    path="/inapp/ios/testtype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/inapp/ios/testconsole"
                    element={<TestConsole_Register />}
                  />
                  <Route
                    path="/inapp/ios/eventstestconsole"
                    element={<TestConsole_Results />}
                  />
                  <Route
                    path="/inapp/ios/eventstestconsole"
                    element={<TestConsole_Results />}
                  />
                  <Route element={<EvgenWrapper />}>
                    <Route
                      path="/inapp/android/evgenevents"
                      element={<TestConsole_Results />}
                    />
                    <Route
                      path="/inapp/ios/evgenevents"
                      element={<TestConsole_Results />}
                    />
                    <Route
                      path="/inapp/android/evgeneventsmanual"
                      element={<InApp_TestSDKIntegration />}
                    />
                    <Route
                      path="/inapp/ios/evgeneventsmanual"
                      element={<InApp_TestSDKIntegration />}
                    />
                  </Route>
                  <Route
                    path="/inapp/android/testtype"
                    element={<TestingTypePath />}
                  />
                  {/* Android */}
                  <Route
                    path="/inapp/android/sendinapp"
                    element={<SendInapp />}
                  />
                  <Route
                    path="/inapp/android/testinappintegration"
                    element={<InApp_TestSDKIntegration />}
                  />
                  <Route
                    path="/inapp/android/testconsole"
                    element={<TestConsole_Register />}
                  />
                  <Route
                    path="/inapp/android/eventstestconsole"
                    element={<TestConsole_Results />}
                  />
                  {/* Ad Revenue  */}
                  <Route path="/adrevenue" element={<AdRevenueSDK />} />
                  <Route
                    path="/adrevenue/android/testsdktype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/adrevenue/android/testconsole"
                    element={<TestConsole_Register />}
                  />
                  <Route
                    path="/adrevenue/android/eventstestconsole"
                    element={<TestConsole_Results />}
                  />
                  <Route
                    path="/adrevenue/android/testadrevenueintegration"
                    element={<AdRevenue_TestManual />}
                  />
                  <Route
                    path="/adrevenue/android/automatedtest"
                    element={<AdRevenue_TestAutomated />}
                  />
                  <Route
                    path="/adrevenue/android/testresults"
                    element={<TestResultManual />}
                  />
                  <Route
                    path="/adrevenue/ios/testsdktype"
                    element={<TestingTypePath />}
                  />
                  <Route
                    path="/adrevenue/ios/testconsole"
                    element={<TestConsole_Register />}
                  />
                  <Route
                    path="/adrevenue/ios/eventstestconsole"
                    element={<TestConsole_Results />}
                  />
                  <Route
                    path="/adrevenue/ios/automatedtest"
                    element={<AdRevenue_TestAutomated />}
                  />
                  <Route
                    path="/adrevenue/ios/testresults"
                    element={<TestResultManual />}
                  />
                  <Route
                    path="/adrevenue/ios/testadrevenueintegration"
                    element={<AdRevenue_TestManual />}
                  />
                  <Route path="/notfound" element={<NotFound />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </div>
          </BrowserRouter>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
